<!-- 公司信息 -->
<template>
    <div v-if="componentsData.type == 12"
        :style="`
            padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px; background: ${componentsData.content.bg_color};
            border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;
        `"
    >
        <div>
            <div class="header">
                <img class="header-img" v-if="companyData.show_logo" :src="companyData.show_logo"/>
                <img class="header-img" v-else :src="componentsData.content.logo.picview"/>
                <div :style="`font-size: ${componentsData.content.title_size}px;color: ${componentsData.content.title_color};`">
                    {{ companyData.company_name }}
                </div>
            </div>
            <div :style="`font-size: ${componentsData.content.size}px;color: ${componentsData.content.text_color};`">
                <div>负责人：{{ companyData.contact }}</div>
                <div class="jc-sb">
                    <div>联系方式：{{ companyData.mobile }}</div>
                    <div class="footer-txt">一键拨号</div>
                </div>
                <div class="jc-sb">
                    <div>公司地址：{{ companyData.address }}</div>
                    <div class="footer-txt">一键导航</div>
                </div>
                <div>公司简介：{{ companyData.desc }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        companyData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.header {
    display: flex;
    align-items: center;
}
.header-img {
    margin: 0 12px 0 0;
    width: 26px;
    height: 26px;
    border-radius: 10px;
}
.footer-txt {
    width: 44px;
    min-width: 44px;
    max-width: 44px;
    font-size: 11px;
    color: #1db85c;
}
.jc-sb {
    display: flex;
    justify-content: space-between;
}
</style>